import { Accept } from "react-dropzone";

import nativePromoQrCode from "assets/images/native-promo/NHNA QR Code 150x150.jpg";
import nativePromoQrCodeModal from "assets/images/native-promo/NHNA QR 260 x 260.jpg";
import nativePromoAppStoreBadge from "assets/images/native-promo/apple-app-store.svg";
import nativePromoGooglePlayBadge from "assets/images/native-promo/google-play-store.svg";

//header
export const SUPPORT_NUMBER = "Support #: 877-214-4431";

//validation
export const REGEX_EMAIL = /^[\w-.]+@([\w-]+\.)+[\w-]{2,7}$/;
export const REGEX_PHONE_PERMITTED_CHARACTERS = /[)( -]+/;
export const REGEX_PHONE_PROHIBITED_CHARACTERS = /[^\d)( -]/;
export const REGEX_PHONE_PERMITTED_LENGTH = /^1?((?:\d){10})$/;

// constants.tsx
export const ApplicationName = "FrontEnd";
export const NH_VERSION = process.env.REACT_APP_NH_FE_VERSION ?? "0.0.0.0";
export const NH_INFO_VERSION = process.env.REACT_APP_NH_FE_INFO_VERSION ?? "0.0.0.0";
//consent links
export const PARTNERSLINK = "https://www.newamericanfunding.com/legal/partners/";
export const TERMSOFUSELINK = "https://www.newamericanfunding.com/legal/terms-of-use-website/";
export const AGREEMENTLINK = "https://www.newamericanfunding.com/legal/electronic-consent-agreement/";
export const PRIVACYLINK = "https://www.newamericanfunding.com/legal/privacy-policy/";
export const NMLSLINK = "https://www.nmlsconsumeraccess.org/TuringTestPage.aspx?ReturnUrl=/EntityDetails.aspx/COMPANY/6606";
export const STATELICENSELINK = "https://www.newamericanfunding.com/legal/state-licensing/";
export const RAPID_APP_REDIRECTION_LINK = "https://www.newamericanfunding.com/lfj-lps/raredirect/";
export const CALIFORNIA_COLLECTION_NOTICE_LINK = "https://www.newamericanfunding.com/legal/privacy-policy/#CAnotice";
export const COOKIE_POLICY_LINK = "https://www.newamericanfunding.com/legal/cookie-policy/";
export const SERVICING_PORTAL_URL = "https://loansphereservicingdigital.bkiconnect.com/newamericanfunding/#/register";

//input type
export const FIRST_NAME = "Please enter your first name.";
export const LAST_NAME = "Please enter your last name";
export const EMAIL = "Please enter your email";
export const MOBILE_NUMBER = "Please enter your phone number";
export const LOAN_PURPOSE = "Please select a loan purpose";

//input errors
export const INVALID_EMAIL_ERROR = "Please enter a valid email address.";
export const INVALID_LOGIN_ERROR = "Password is incorrect, please try again";
export const INVALID_PASSWORD_ERROR = "Password is invalid";
export const CONFIRM_PASSWORD = " Please confirm your password.";

//input required
export const REQUIRED_EMAIL = "Please enter your email";
export const REQUIRED_PASSWORD = "Please enter your password";
export const REQUIRED_PASSWORD_CONFIRMATION = "Please confirm your password";

//Phone number erros
export const REQUIRED_PHONE_ERROR = "Please enter your phone number";
export const REQUIRED_SPOUSE_PHONE_ERROR = "Please enter your spouse's phone number";
export const REQUIRED_COBORROWER_PHONE_ERROR = "Please enter your co-borrower's phone number";
export const INVALID_PHONE_ERROR = "Please enter a valid phone number";
export const INVALID_PHONE_LENGTH_ERROR = "Phone number must contain 10 digits";

//password checker phrases
export const PWD_CHECK_MIN_LENGTH = "Be a mininum of 8 characters";
export const PWD_CHECK_UPPER_CASE = "Include at least one uppercase letter (A-Z)";
export const PWD_CHECK_LOWER_CASE = "Include at least one lowercase letter (a-z)";
export const PWD_CHECK_NUMBER = "Include at least one number (0-9)";
export const PWD_CHECK_SPECIAL_CHAR = 'Include at least one special character ("#$%,etc.)';
export const PWD_MATCH_ERROR = " Passwords don't match. Please try again. ";

//updated password checker phrases
export const NEW_PWD_CHECK_MIN_LENGTH = "At least 10 characters";
export const NEW_PWD_CHECK_UPPER_CASE = "Upper case letter";
export const NEW_PWD_CHECK_LOWER_CASE = "Lower case letter";
export const NEW_PWD_CHECK_NUMBER = "Number";
export const NEW_PWD_CHECK_SPECIAL_CHAR = "Special character";
export const NEW_PWD_CHECK_UNIQUE_SPECIAL_CHARS = "At least 5 different characters (example: Abcde1!234)";
export const NEW_PWD_MATCH_ERROR = " Passwords don't match. Please try again. ";

//Date Warning
export const DATE_LIMIT_WARNING_MESSAGE = "The date you entered exceeds a reasonable amount of years. Please update if incorrect.";
export const YEAR_WARNING_LIMIT_VALUE = 98;
export const ALLOWED_YEAR_START_VALUE = 1900;

//password min characters
export const PWD_MIN_LENGTH = 10;

export const BASE_BFF_WEB_URL = window.env.REACT_APP_BASE_BFF_WEB_URL;
export const DEFAULT_HTTP_TIMEOUT = 1000; //units in milliseconds
export const ESIGN_SCRIPT_URL = window.env.ESIGN_SCRIPT_URL;
export const ESIGN_DATA_SITE_ID = window.env.ESIGN_DATA_SITE_ID;
export const TTD_CODE_SNIPPET_URL = window.env.TTD_CODE_SNIPPET_URL;
export const TRANSPERFECT_SCRIPT_URL = window.env.TRANSPERFECT_SCRIPT_URL;
export const TRANSPERFECT_SCRIPT_DATA_OLJS = window.env.TRANSPERFECT_SCRIPT_DATA_OLJS;
export const DROPDOWN_YEARS_FOR_CALENDAR = 40;

export const MAX_RACE_SELECTIONS = 5;

export const DISPLAY_STEP_CODE = window.env.DISPLAY_STEP_CODE;

export const CONTACT_US = "855-744-6990";

export const REQUIRED_CODE = "Invalid Code";

// error message contact details
export const Support = "(877) 214-4431";
export const PhoneNumber = "877-214-4431";

// errors
export const RegistrationError = ["There was an error with your registration.", ` Please contact Technical Support at ${Support}.`];

export const CreatePasswordFieldEmptyError = "You must create a password";

//MFA errors
export const LoginError = ["There was an error with your login.", `Please contact Technical Support at ${Support}`];

export const OTP_EXPIRED_ERROR = "Code is expired. Please click Resend Code and try again.";
export const INVALID_OTP_ERROR = "Invalid code";
export const OTP_GENERIC_MESSAGE = "Enter your 6-digit code below";
export const OTP_PHONE_MESSAGE = "Enter your 6-digit code sent to your phone below";
export const RESET_PASSWORD_ERROR = "Please use a password you haven't used before.";
export const RESET_PASSWORD_CODE_ERROR = "Invalid password reset code";
export const RESET_PASSWORD_INVALID_REQUEST = "Password reset link expired";

//footer
export const FOOTER_CONTACT_US = "(855) 744-6990";
export const FOOTER_COPYRIGHT = `© ${new Date().getFullYear()} New American Funding, LLC. All Rights Reserved.`;
export const ForgotPasswordError = [`There was an error with your password reset.Please contact Technical Support at ${Support}`];

//Mortgage button
export const MortgageButton = "https://www.newamericanfunding.com/myloan/";

//Login error
export const DefaultLoginError = [`There was an error with your login. `, `Please contact Technical Support at`, `${Support}.`];
export const MultipleAttemptFailure = [
  `Maximum number of attempts reached. `,
  `Please try again in 10 minutes `,
  `or click on the Forgot Password link.`,
];
export const InvalidPassword = [`Invalid email address or password`];

//Token
export const ACCESS_TOKEN_EXPIRATION_MINUTES = 60;
export const SKEW_TIME_IN_MINUTES = 0.5;

//Dashboard
export const DASHBOARD_LOAN_PROGRESS_STATUS_UNKNOWN_WARN =
  "We are unable to provide current status at this time. Please check back later or contact your Loan Officer.";

export const DASHBOARD_LOAN_INFO_WARNING =
  "We are having technical issues displaying your most recent status.  Please check back later or contact your Loan Officer";

export const DASHBOARD_MAXFILES_LIMIT_REACHED_ERROR =
  "You’ve reached the max limit of 12 documents. To upload more, please delete some files or return to the dashboard after completing this round of uploads.";

export const DOCUMENT_MAX_SIZE_IN_BYTES = 20 * 1024 * 1024;
export const FILE_UPLOADER_DEFAULT_MAX_SIZE_IN_BYTES = 40 * 1024 * 1024;
export const DOCUMENT_UPLOAD_TIMEOUT_MS = 5 * 60 * 1000;

//Old Legal Information
export const Legal_Information_One = "By clicking “Continue”, I acknowledge that I have reviewed the ";
export const Legal_Information_Two =
  " and agree by ESIGN signature to the following: 1) I am providing written instructions under the Fair Credit Reporting Act authorizing New American Funding (NAF) to obtain information from my personal credit profile or other information from a consumer reporting agency solely to conduct a prequalification for credit. 2) Receive disclosures and communications about my loan inquiry and any loan that I obtain from NAF in electronic form. (I confirm I have access to a working computer and/or digital device where I can view and manage my information.) 3) I consent to NAF, its ";
export const Legal_Information_Three =
  ", and parties calling on their behalf to contact me at the number that I provided above for marketing purposes, including through the use of email, automated technology, artificial or prerecorded voice, AI generative voice, and SMS/MMS messages. I acknowledge my consent is not required to obtain any good or service, and that I can be connected with NAF without providing consent by calling  (800) 890-1057 . I consent to be contacted even if my phone number or email address appears on a NAF Do Not Contact/Do Not Email list, a State or National Do Not Call Registry or any other Do Not Contact/Do Not Email list.";
export const Legal_Information_Four = " 4) To the terms of NAF’s  ";
export const LOGIN_PAGE_OLD_CONSENT = (
  <>
    By continuing, you agree to our{" "}
    <a href={TERMSOFUSELINK} target="_blank" rel="noreferrer">
      Terms of Use
    </a>
  </>
);
//Assistant Note
export const Assistant_Note = (
  <p>
    If you are using a screen reader or other auxiliary aid and are having problems using this website please call <strong>800-450-2010</strong> Ext.
    7100 for assistance.
  </p>
);

export const Policy_Note = "By using our site, you agree to our use of cookies. For more information, read our ";

//Dashboard headers
export const MyDashboard = "My Dashboard";
export const MyDocuments = "My Documents";

//LoanStatus
export const Funded = "Funded";

//ApplicationRoles
export const ApplicationRoleTypes = {
  PrimaryBorrower: "PrimaryBorrower",
  NonSpousalCoBorrower: "NonSpousalCoBorrower",
  NonBorrowerOwner: "nonborrowerowner"
};

export const LoanStatusNames = {
  Unknown: "Unknown",
  Started: "Started",
};

export const ApplicationStatusNames = {
  Completed: "Completed",
  InProgress: "InProgress",
};

export const LoanPurposeNames = {
  Purchase: "Purchase",
  Refinance: "Refinance",
};

//Registration Page Greeting texts

export const puchasePathGreeting = "Next Step to Your New Home!";
export const refinancePathGreeting = "Next Step to Your Financial Goals!";
export const unknownPurposeGreeting = "Discover your lending options.";
export const createPasswordGreetingDesktopView = [
  "A loan specialist will call you soon to",
  "discuss your options. Meanwhile, create a profile",
  "with a password to continue the application.",
];
export const createPasswordGreetingPurchaseMobileView = [
  "A loan specialist will call you soon to",
  "discuss your options. Meanwhile,",
  "create a profile with a password to",
  "continue the application.",
];
export const createPasswordGreetingRefinanceMobileView = [
  "A loan specialist will call you soon to",
  "discuss your options. Meanwhile, create a",
  "profile with a password to continue",
  "the application.",
];
export const createPasswordGreeting = ["Simply create a profile with a password", "to continue the application."];
export const defaultCoBorrowerGreeting = [
  "To get started, please create a password so that you can come back to this information, at your convenience.",
];
export const palGreetingText = ["Create a password below to upload, view and manage required", "mortgage documents, and track your loan progress!"];
export const palGreetingTextMobile = [
  "Create a password below to upload, view",
  "and manage required mortgage",
  "documents, and track your loan progress!",
];
export const DigitalLeadGreeting = "Set up your account to stay on track and monitor your progress every step of the way.";
export const registrationInformation = [
  `Complete the questionnaire`,
  `Upload required docs`,
  `Talk to a loan officer`,
];
// Welcome Page

export const welcomeHeader = (
  <>
    Easy. Secure. <br className="mobile-break" />
    Reliable
  </>
);

export const welcomeSubtext = (
  <>
    Quickly complete your application, securely upload your documents, and talk to a Loan Officer, to
    <br className="desktop-break" /> review your options.
  </>
);

// External Registration Page

export const registerExternalUserDesktopViewContent =
  "Create a password below to upload, view and manage required mortgage documents and track your loan progress!";
export const registerExternalUserMobileViewContent = (
  <>
    Create a password below to upload, view
    <br />
    and manage required mortgage
    <br /> documents and track your loan progress!
  </>
);

export const NoLoanInfoText =
  "We are unable to provide property and loan details at this time. Please check back later or contact your Loan Officer.";

export const NafInsuranceAd_Purchase =
  "For your home loan, you’ll need to provide proof of insurance. NAF Insurance has you covered, shopping 40+ top carriers in seconds to save you time and money. On average, NAF Insurance customers are saving $638 annually and closing their loan 2 days faster!";
export const NafInsuranceAd_Refinance =
  "If you’re refinancing your home, why not also “refinance” your home insurance? NAF Insurance is saving customers $638 annually, on average, compared to their previous policy, shopping 40+ top carriers in seconds.";
export const NafInsuranceAd_Disclaimer_Title = "Disclaimer";
export const NafInsuranceAd_Disclaimer_Content =
  "*New American Funding is not a licensed insurance agency or broker and does not provide insurance quotes to consumers in compliance with applicable state insurance licensing statutes. While you are required to get home insurance before closing, you are not required to get insurance through NAF Insurance - or any particular broker.";
export const NafInsuranceAd_Loader_Message1 = "Bundle Home and Auto coverage to unlock additional Savings";
export const NafInsuranceAd_Loader_Message2 = "Please do not refresh or click Back in your browser";
export const NafInsurance_Loader_Header_desktop = "We’re transferring you to NAF Insurance powered by Matic";
export const NafInsurance_Loader_Header_Mobile_Part1 = "We’re transferring you to";
export const NafInsurance_Loader_Header_Mobile_Part2 = "NAF Insurance powered by Matic";

export const DefaultAllowedExtension = "pdf";
export const DefaultAcceptedFileType: Accept = {
  "application/pdf": [`.${DefaultAllowedExtension}`],
};
export const AvailableFileTypes: Accept = {
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
  "image/emf": [".emf"],
  "image/jpeg": [".jpg", ".jpeg", ".jpe"],
  "application/pdf": [".pdf"],
  "image/png": [".png"],
  "image/tiff": [".tif", ".tiff"],
  "text/plain": [".txt"],
  "application/vnd.ms-xpsdocument": [".xps"],
};

export const PalDocumentDefaultName = "PreApprovalLetter.pdf";

export const PalInstanceQueryString = "palInstanceId";
export const NotificationIdQueryString = "Id";
export const LatestPal = "latestPal";

//condition based constant
export const AdditionalDocumentationCondition = "Additional Documentation - Upload documents that have been requested";
export const DefaultConditionsCount = 1;

//source code
export const RAPID_APP_SOURCE_CODE = 12345678;

//StepCodes
export const VOA_StepCodes = ["H14", "H20"];
export const VOI_StepCodes = ["G200", "G201"];
export const Verification_Spouse_StepCodes = ["G201", "H20"];
export const LEAD_FLOW_COMPLETED_STEPS = ["C1", "C16"];

//VOA terms of service link
export const VOA_TOS_LINK = "https://verifier.accountchek.com/tos";

//Uqual Redirect link
export const UQUAL_REDIRECT = "https://www.newamericanfunding.com/partners/loanready/uqual/";

export const UQUAL_COMPLETE_NOTE =
  "Borrowers who complete the Uqual Loan Readiness program are eligible for a $500 lender credit upon funding of NAF mortgage loan.";
export const UQUAL_CONTACT_NUMBER = "(720) 647-3161";
//External redirections
export const EXTERNAL_REDIRECTION_TOKEN = "externalRedirectionToken";
export const EXTERNAL_REDIRECTION_TYPE_INSURANCE = "externalRedirectTypeInsurance";

//ESign rediretion
export const ESIGN_REDIRECTION_TOKEN = "eSignRedirectionToken";

//Dashboard Session
export const DASHBOARD_SESSION_ID = "dashboardSessionId";
export const DASHBOARD_SESSION_START_TIMESTAMP = "sessionStartTimestamp";

export const DASHBOARD_CREATE_NEEDS_TRIGGERED = "hasCreateNeedsTriggeredForSession";
export const DASHBOARD_CREATE_NEEDS_TRIGGERED_TRUE = "true";

export const Transition_Total_Steps = 3;
export const Transition_StepOne_TimeOut = 3000;
export const Transition_StepTwo_TimeOut = 11000;
export const Transition_StepThree_TimeOut = 18000;
export const Transition_Steps = ["Application Received", "Reviewing your information", "Setting up your dashboard"];

export const PRIVACY_AND_TERMSOFUSE_CONSENT = (
  <>
    By clicking “Continue”, I acknowledge that I have reviewed the{" "}
    <a href={PRIVACYLINK} target="_blank" rel="noreferrer">
      Privacy Policy
    </a>{" "}
    and agree to the{" "}
    <a href={TERMSOFUSELINK} target="_blank" rel="noreferrer">
      Terms of Use
    </a>
    .
  </>
);

export const WELCOME_PAGE_CONSENT = (
  <>
    By clicking “Continue”, I agree by ESIGN signature 1) to receive disclosures and communications about my loan inquiry and any loan that I obtain
    from New American Funding (NAF) in electronic form (I confirm I have access to a working computer and/or digital device where I can view and
    manage my information); and 2) to the&nbsp;
    <a href={AGREEMENTLINK} target="_blank" rel="noreferrer">
      Electronic Consent Agreement
    </a>
    ; and 3) I consent to NAF, its&nbsp;
    <a href={PARTNERSLINK} target="_blank" rel="noreferrer">
      partners
    </a>
    , and parties calling on their behalf to contact me at the number that I provided on the previous screen for marketing purposes, including through
    the use of email, automated technology, artificial or prerecorded voice, AI generative voice, and SMS/MMS messages. I acknowledge my consent is
    not required to obtain any good or service, and that I can be connected with NAF without providing consent by calling (800) 890-1057. I consent to
    be contacted even if my phone number or email address appears on a NAF Do Not Contact/Do Not Email list, a State or National Do Not Call Registry
    or any other Do Not Contact/Do Not Email list.
  </>
);
export const CREDIT_PAGE_CONSENT =
  "By clicking “Continue”, I am providing written instructions under the Fair Credit Reporting Act authorizing New American Funding (NAF) to obtain information from my personal credit profile or other information from a consumer reporting agency solely to conduct a prequalification for credit.";
export const DASHBOARD_CONDITION_TILE_HEADER = "Tasks to be completed";
export const DASHBOARD_CONDITION_TILE_ERROR =
  "We're unable to load your tasks list at the moment. Please try again later. We apologize for the inconvenience!";
export const DASHBOARD_CONDITION_NEEDS_ATTENTION = "needsAttention";
export const DASHBOARD_NEEDS_STATUS_UNDER_REVIEW = "underReview";
export const PENDING_APPROVAL = "Pending Approval";

//ADA footer texts
export const ADA_SUPPORT_TEXT1 = "If you are using a screen reader or other auxiliary aid and are having problems using this website, please call ";
export const ADA_SUPPORT_TEXT2 = " for assistance.";
export const ADA_SUPPORT_CONTACT = "800-450-2010 Ext. 7100";

//needs action
export const ESIGN_ACTION_TEXT = "E-Sign";
export const ESIGN_COMPLETED_TEXT = "View";

//Esign Status
export const ESIGN_STATUS_NEW = "new";
export const ESIGN_STATUS_UNDER_REVIEW = "underreview";
export const ESIGN_STATUS_COMPLETED = "completed";

//ESign drawer content
export const ESIGN_TITLE = "E-Sign Portal";
export const ESIGN_CLOSE_BUTTON_TEXT = "Close E-sign Portal";
export const ESIGN_FOOTER_TEXT = "E-sign your disclosures with Simplifile®, a trusted New American Funding partner.";
// eSign title type prefixes
export const DISCLOSURE_TITLE_PREFIX = "disclosuresready" as const;
export const CLOSING_DISCLOSURE_TITLE_PREFIX = "closingdisclosureready" as const;
//ESign Under Review Modal
export const UNDER_REVIEW_TITLE = "Under Review";
export const UNDER_REVIEW_DESCRIPTION =
  "If you e-signed all your documents, we will mark this task as completed shortly. If you didn’t finish, you can still enter the task again to complete it.";
//document upload status
export const UPLOAD_STATUS_ERROR = "Error";
export const UPLOAD_STATUS_REUPLOAD = "Re-upload";
export const UPLOAD_STATUS_UPLOAD = "Upload";

// Loan Officer Card
export const LOAN_OFFICER_CARD_UNFORMATTED_PHONE_NUMBER = "855-566-1102";
export const LOAN_OFFICER_CARD_FORMATTED_PHONE_NUMBER = "(855) 566-1102";
export const LOAN_OFFICER_CALL_QUEUE = "Call Queue";

// Sort dropdown options
export const SORT_BY_TITLE = "Sort by Title";
export const SORT_BY_DATE = "Sort by Date";

// Document filter options
export const FILTER_NAF = "naf";

// Uqual Banner/Modal
export const UQUAL_AD_BANNER_TITLE_DESKTOP = "Improve your credit and get mortgage-ready with Uqual";
export const UQUAL_AD_BANNER_TITLE_MOBILE = "Improve your credit";
export const UQUAL_AD_BANNER_SUBTITLE_DESKTOP = "";
export const UQUAL_AD_BANNER_SUBTITLE_MOBILE = "and get mortgage-ready with Uqual";
export const UQUAL_AD_BANNER_CTA = "Start Now";
export const UQUAL_BANNER_HEADER = "Get Mortgage Ready with Uqual!";
export const UQUAL_MODAL_HEADER = "Build Your Path to Approval with Uqual";
export const UQUAL_MODAL_SUBHEADER =
  "Want a plan that actually makes sense for your goals? Click below and a Uqual advisor will help you sort out your credit, savings, and what comes next. No pressure, just a real person who's here to help you get loan ready.";
export const UQUAL_MODAL_DISCLAIMER =
  "Services described are provided through UQUAL LLC, a loan readiness company providing financial tools, loan readiness coaches, and customized plans to get consumers ready to qualify for a loan. UQUAL LLC is not a credit repair company and does not provide credit repair, debt settlement, legal or tax guidance.";
export const UQUAL_MODAL_ACCEPT_BUTTON = "Yes, Contact Me";
export const UQUAL_MODAL_DECLINE_BUTTON = "Remind Me Later";
export const UQUAL_MODAL_FOOTER = "A Uqual Advisor will reach out shortly to walk you through your personalized readiness plan.";
export const UQUAL_MODAL_SUCCESS_HEADER = "You're All Set! A Uqual Advisor Will Reach Out Soon";
export const UQUAL_MODAL_SUCCESS_BODY =
  "Borrowers who complete the Uqual Loan Readiness program may be eligible for a $500 lender credit when funding a mortgage with NAF.";
export const UQUAL_MODAL_SUCCESS_HEADER_SECONDARY = "Ready to Talk Now?";
export const UQUAL_MODAL_SUCCESS_SUBHEADER_SECONDARY_BEFORE_NUMBER = "Call us directly at ";
export const UQUAL_MODAL_SUCCESS_SUBHEADER_SECONDARY_AFTER_NUMBER = " to speak with a Uqual advisor today.";
export const UQUAL_MODAL_SUCCESS_DISCLAIMER_SECONDARY =
  "This is not mortgage advice or a commitment to lend. There are no guarantees, promises, representations and/or assurances concerning the results you may experience. $500 lender credit will be applied to closing costs at time of loan funding. The first-lien mortgage loan must lock within two years of signing up with Uqual. Only available on new applications with New American Funding, not applications already in progress. Due to maximum seller concession rules applicable to first-lien loan transactions, this credit could be less than $500 in some cases where other concessions have been made to the consumer. Please consult your Loan Officer with questions.";

// Native app promo card
export const NATIVE_APP_PROMO_TITLE = "Your loan in your pocket";
export const NATIVE_APP_PROMO_SUBTITLE = "Your loan path, always within reach.";
export const NATIVE_APP_PROMO_GET_APP_BUTTON_LABEL = "Get the app";
export const NATIVE_APP_PROMO_SCAN_TO_DOWNLOAD = "Scan to download";
export const NATIVE_APP_PROMO_POINT_CAMERA_HELPER = "Point your phone camera at this code";
export const NATIVE_APP_PROMO_AD_NAME = "NAF Hub App";
export const NATIVE_APP_PROMO_MODAL_TITLE = "Get the NAF Hub app";
export const NATIVE_APP_PROMO_MODAL_HELPER_TEXT = "Point your phone camera at the code to download";
export const NATIVE_APP_PROMO_MODAL_MAYBE_LATER = "Maybe later";
export const NATIVE_APP_PROMO_QR_FALLBACK_TEXT = "QR code unavailable";

export const NATIVE_APP_PROMO_QR_IMAGE_URL = nativePromoQrCode;
export const NATIVE_APP_PROMO_QR_IMAGE_URL_MODAL = nativePromoQrCodeModal;
export const NATIVE_APP_PROMO_APP_STORE_BADGE_URL = nativePromoAppStoreBadge;
export const NATIVE_APP_PROMO_GOOGLE_PLAY_BADGE_URL = nativePromoGooglePlayBadge;

export const NATIVE_APP_PROMO_APP_STORE_URL = "https://onelink.to/nafhub";
export const NATIVE_APP_PROMO_GOOGLE_PLAY_URL = "https://onelink.to/nafhub";

// Native app banner card
export const NATIVE_APP_BANNER_TITLE = "Get the NAF Hub app";
export const NATIVE_APP_BANNER_SUBTITLE = "Track your loan on the go!";
export const NATIVE_APP_BANNER_SCAN_QR_LABEL = "Scan QR code";
export const NATIVE_APP_BANNER_GET_APP_LABEL = "Get the app";
export const NATIVE_APP_BANNER_DISMISS_KEY = "NATIVE_APP_BANNER_DISMISSED";
export const NATIVE_APP_AD_ELIGIBILITY_KEY = "NATIVE_APP_AD_ELIGIBILITY";
export const UQUAL_AD_BANNER_DISMISS_KEY = "UQUAL_AD_BANNER_DISMISSED";
export const UQUAL_AD_FIRST_SESSION_KEY = "UQUAL_AD_FIRST_SESSION";
export const UQUAL_NOTIFICATION_TITLE = "NAF Home Services";
export const UQUAL_NOTIFICATION_TEXT = "Get mortgage—ready with Uqual. See how to get started.";

// Summary Page
export const SUMMARY_PAGE_TOAST_MESSAGE_TIMEOUT = 3000;

// NPS Rating Modal
export const NPS_MODAL_HEADER = "Your Feedback Matters";
export const NPS_MODAL_SUBTITLE = "On a scale of 0–10, how likely are you to recommend New American Funding to friends and family?";
export const NPS_MODAL_VERY_LIKELY_LABEL = "Very Likely";
export const NPS_MODAL_UNLIKELY_LABEL = "Unlikely";
export const NPS_MODAL_LIKELY_LABEL = "Likely";
export const NPS_MODAL_VERY_LIKELY_DESCRIPTION = "What do you love the most about New American Funding?";
export const NPS_MODAL_UNLIKELY_DESCRIPTION = "What could we do to improve your experience?";
export const NPS_MODAL_LIKELY_DESCRIPTION = "What is the primary reason for your score?";
export const NPS_MODAL_CHARACTER_LIMIT = 300;
export const NPS_MODAL_COMMENT_PLACEHOLDER = "Enter Comment";
export const NPS_SCROLL_TIMEOUT = 50;
export const NPS_MOUNT_TIMEOUT = 800;
export const NPS_INITIAL_SCROLL_OFFSET = 300;
export const NPS_FEEDBACK_SUBMISSION_SUCCESS_HEADER = "Thanks so much for your feedback! Your input helps us make our service better for everyone.";
export const CTC_POPUP_DURATION = 3000;

// Clear to Close Popup
export const CTC_POPUP_HEADER = "Congratulations!";
export const CTC_POPUP_DESCRIPTION = "You are Cleared-to-Close";
export const LOAN_STATUS = {
  CLOSE: "Close",
};
export const NPS_RETRY_LIMIT = 2;
export const NPS_LAST_SESSION = "npsLastSession";

export const ErrorCodeInvalidMFA = "Invalid Mfa Setup";
export const PROFILE_ERROR_LOAD_NAME = "Failed to load name";
export const PROFILE_ERROR_LOAD_EMAIL = "Failed to load email";
export const PROFILE_ERROR_LOAD_PHONE = "Failed to load phone number";
export const PROFILE_ERROR_LOAD_INFO = "Unable to load your profile information. Please try again later.";
export const PROFILE_SETTINGS_TITLE = "Profile Settings";
export const PROFILE_NAME_LABEL = "Name";
export const PROFILE_LABEL_PHONE = "Home";
export const PROFILE_CONTACT_INFO_LABEL = "Contact Info";
export const PROFILE_EMAIL_LABEL = "Email";
export const PROFILE_PHONE_LABEL = "Phone";
export const PROFILE_COMMUNICATION_PREFERENCES_LABEL = "Communication Preferences";
export const PROFILE_COMMUNICATION_PREFERENCES_SUBTITLE = "Let us know how you want to hear from us.";
export const PROFILE_RESET_PASSWORD_LABEL = "Reset Password";
export const PROFILE_RESET_PASSWORD_SUBTITLE = "A strong password is a great way to keep your account secure.";
export const LOAN_OFFICER_LABEL = "Loan Officer";
export const NAF_HOME_SERVICES_LABEL = "NAF Home Services";
export const NAF_HOME_SERVICES_DESCRIPTION = "Lorem ipsum dolor sit amet, consectetur adipiscing elit.";
// Loan Details - Overview
export const LOAN_DETAILS_CARD_PENDING_STATUS_TEXT = "Pending";
export const LOAN_DETAILS_CARD_ADDRESS_LABEL = "Property Location";
export const LOAN_DETAILS_CARD_LOAN_PURPOSE_LABEL = "Loan Purpose";
export const LOAN_DETAILS_CARD_LOAN_AMOUNT_LABEL = "Loan Amount";
export const LOAN_DETAILS_CARD_LOAN_NUMBER_LABEL = "Loan Number";
export const LOAN_DETAILS_CARD_LOAN_PROGRAM_LABEL = "Loan Program";
export const LOAN_DETAILS_CARD_PURCHASE_PRICE_LABEL = "Purchase Price";
export const LOAN_DETAILS_CARD_DOWN_PAYMENT_LABEL = "Down Payment";
export const LOAN_DETAILS_CARD_PROPERTY_ADDRESS_LABEL = "Property Address";
// Loan Details - Terms 
export const LOAN_DETAILS_CARD_LOAN_TERM_LABEL = "Loan Term";
export const LOAN_DETAILS_CARD_LOAN_TYPE_LABEL = "Loan Type";
export const LOAN_DETAILS_CARD_PROPERTY_USE_LABEL = "Property Use";
export const LOAN_DETAILS_CARD_INTEREST_RATE_LABEL = "Interest Rate";
export const LOAN_DETAILS_CARD_APR_LABEL = "APR";
export const LOAN_DETAILS_CARD_INTEREST_RATE_LOCK_STATUS_LABEL = "Interest Rate Lock Status";
export const LOAN_DETAILS_CARD_RATE_AMORTIZATION_TYPE_LABEL = "Rate Amortization Type";
export const LOAN_DETAILS_CARD_ESTIMATED_TOT_MON_PAYMENT_LABEL = "Estimated Total Monthly Payment";
export const LOAN_DETAILS_CARD_PRINCIPAL_INTEREST_LABEL = "Principal & Interest";
export const LOAN_DETAILS_CARD_PROPERTY_TAX_LABEL = "Property Tax";
export const LOAN_DETAILS_CARD_INSURANCE_LABEL = "Insurance";
export const LOAN_DETAILS_CARD_ASSOCIATION_DUES_LABEL = "Association Dues";
export const LOAN_DETAILS_CARD_OTHER_LABEL = "Other";
export const LOAN_DETAILS_CARD_SUPPLEMENTAL_PROPERTY_INSURANCE_LABEL = "Supplemental Property Insurance";
export const LOAN_DETAILS_CARD_MORTGAGE_INSURANCE_LABEL = "Mortgage Insurance";
export const LOAN_DETAILS_CARD_SUBORDINATE_FINANCING_LABEL = "Subordinate Financing";
// Loan Details - Dates
export const LOAN_DETAILS_CARD_ESTIMATED_CLOSING_DATE_LABEL = "Estimated Closing Date (Subject to Change)";
export const LOAN_DETAILS_CARD_RATE_LOCK_EXPIRATION_LABEL = "Rate Lock Expiration";

export const VIEW_DETAILS_BUTTON_TEXT = "View Details";
export const LOAN_DETAILS_CARD_ERROR_MESSAGE = "We are unable to display loan details. Please try again later.";
export const TASK_CARD_TITLE = "Tasks";
export const TASK_CARD_HEADING_TEXT = "These are your outstanding tasks.  Complete them to keep moving forward.";
export const NOTIFICATIONS_TITLE = "Notifications";
export const NOTIFICATIONS_EMPTY_TEXT = "No new notifications";
export const NOTIFICATIONS_ESIGN_TITLE = "Disclosures Ready";
export const NOTIFICATIONS_ESIGN_TEXT = "Take Action: Go to your Tasks page to complete Disclosures";

export const TASK_ERROR_CARD_DESCRIPTION_DESKTOP = "We're having a technical issue on our end.";
export const TASK_ERROR_CARD_DESCRIPTION_MOBILE = "We're having a technical issue displaying the details on our end. Our team is working to resolve it.\n For support, call 877-241-4431.";
export const TASK_ERROR_TITLE_UNDER_REVIEW = "Task is under review";
export const TASK_ERROR_TITLE_DOCUMENT_UNAVAILABLE = "Document task unavailable";
export const TASK_ERROR_DETAILS_TEMPORARILY_UNAVAILABLE = "Details temporarily unavailable on our end.";
export const TASK_ERROR_ESIGN_TITLE = "E-sign task unavailable";
export const TASK_ERROR_ESIGN_DESCRIPTION = "We're experiencing a technical issue on our end and couldn't load your signing task. We understand this is important and our team is working to resolve it.";
export const TASK_ERROR_DOCUMENT_CARD_TITLE = "Document tasks unavailable";
export const TASK_ERROR_DOCUMENT_DESCRIPTION = "We're experiencing a technical issue on our end and couldn't load this document task. We understand this is important and our team is working to resolve it.";
export const TASK_ERROR_REVIEW_DESCRIPTION = "Your documents have been received and are currently being reviewed by your loan officer. We're having a technical issue displaying the details on our end.";
export const TASK_ERROR_SUPPORT = "For support, call 877-214-4431.";
export const TASK_ERROR_COMPLETE_ESIGN_TITLE = "E-sign task complete";
export const TASK_ERROR_COMPLETE_ESIGN_LEFT_DESCRIPTION = "Details temporarily unavailable on our end.";
export const TASK_ERROR_COMPLETE_ESIGN_RIGHT_DESCRIPTION = "Your signed documents have been successfully submitted. We're having trouble displaying the details due to a technical issue on our end—they'll be available shortly.";
export const TASK_ERROR_COMPLETE_DOCUMENT_TITLE = "Task complete";
export const TASK_ERROR_COMPLETE_DOCUMENT_LEFT_DESCRIPTION = "Details temporarily unavailable on our end.";
export const TASK_ERROR_COMPLETE_DOCUMENT_RIGHT_DESCRIPTION = "Your documents have been successfully submitted. We're having a technical issue displaying the details on our end—they'll be available shortly.";
export const TASK_NEEDS_LOAD_ERROR_TITLE = "Tasks unavailable";
export const TASK_NEEDS_LOAD_ERROR_DESCRIPTION = "We're experiencing a technical issue on our end and couldn't load your tasks. Our team is working to resolve it.";
export const TASK_STATUS_REFRESH_ERROR = "Unable to retrieve the latest status. Please refresh the page to load the latest information.";

//Uqual Advisor Drawer
export const UQUAL_ADVISOR_CARD_SUBTITLE = "Raising your credit score can help you qualify for a mortgage and save thousands.";
export const UQUAL_ADVISOR_DRAWER_DISCLAIMER_TEXT =
  'By clicking "Yes, Contact Me", a Uqual Advisor will reach out shortly to walk you through your personalized readiness plan.';
export const UQUAL_ADVISOR_DRAWER_DISCLAIMER = "Disclaimer";
export const UQUAL_ADVISOR_DRAWER_REVIEW_CONTNT =
  '"Chris is awesome! Currently working on getting all my credit situated and also going to get my husband involved, cause Lord knows we need it! So excited to get the ball rolling. Thanks again, Uqual! Everyone in this company and New American Funding I\'m working with has just had the best attitude and it makes me so comfortable. Adding to note that Ruth Branham is super sweet, and everyone is always so great at communicating."';
export const CUSTOMER_REVIEW = "Customer Review";
export const UQUAL_CALL_DIRECTLY = "Call Uqual directly at";
export const UQUAL_CALL_DIRECTLY_2 = "to speak with a Uqual advisor today.";

export const DASHBOARD_MAXFILES_LIMIT_REACHED_WARNING =
  "Maximum of 12 files per upload exceeded. Delete files to get to 12 or less, then click Submit.  You can upload more after.";

export const FILE_TOO_LARGE_CODE = "file-too-large";
export const FILE_INVALID_TYPE_CODE = "file-invalid-type";
export const FILE_TOO_LARGE_MSG = "File size exceeded";
export const FILE_INVALID_TYPE_MSG = "File type invalid";

export const ENHANCED_CONDITION_UPLOAD_ERROR_DESCRIPTION =
  "We couldn't upload your documents, please try again later.\nWe apologize for the inconvenience!";

// error messages
export const ERROR_MESSAGE = "Something went wrong";
export const INTERNAL_ERROR_MESSAGE = "Internal error. Please try again later. We apologize for the inconvenience.";
export const COMPLETED_TASKS_DOC_LOAD_ERR_TEXT =
  "We are having issues loading your documents, please try again later. \n We apologize for the inconvenience!";

// exit survey
export const EXIT_SURVEY_QUESTIONS = [
  {
    question: "Reason you’re leaving today",
    options: [
      "I was hoping to see rates or loan options.",
      "The application seems too long or confusing.",
      "I will return to complete the application.",
      "I'm just exploring and not ready to apply yet.",
      "Other",
    ],
  },
  {
    question: "Have you had a chance to connect with a loan officer?",
    options: [
      "Yes, I've already spoken with one.",
      "No, but I'd like to.",
      "No, I'm not ready for that yet."
    ]
  }
];
export const EXIT_SURVEY_LIMIT = 1;
export const NOT_AVAILABLE = "Not Available";
export const LOCKED = "Locked";
export const NOT_LOCKED = "Not Locked";
export const LOCAL_STORAGE_KEY = "preferredLanguage";
export const DEFAULT_LANGUAGE = "English";
export const LANG_PREF_COOKIE_NAME = "langPref";
export const SPANISH_LANG_CODE = "es-us";


export const SUPPORTED_LANGUAGES = ["English", "Español"];

export const SPANISH_LEGAL_COPY = `New American Funding se complace en ofrecer traducciones al español de algunos documentos y comunicaciones para nuestros clientes de habla hispana. Al cambiar al español y continuar más allá de esta ventana, usted indica su preferencia por revisar esta página web y sus documentos adjuntos en español. Si no desea continuar en español en este momento, por favor seleccione "Cancelar" y será redirigido a la versión en inglés del sitio web NAF Hub.

Hemos realizado esfuerzos para traducir tantos documentos como ha sido posible; sin embargo, algunos documentos podrían permanecer únicamente en inglés. Las traducciones al español que hemos proporcionado tienen fines meramente informativos. Las versiones en inglés —incluida la Solicitud Uniforme de Préstamo Residencial (URLA) en inglés— serán siempre los documentos oficiales y legales de servicio que usted firmará y que tendrán carácter jurídicamente vinculante. Si surgiera alguna discrepancia entre la traducción al español y la URLA en inglés, se considerará correcta la versión final firmada de la URLA en inglés, la cual regirá la transacción. Si bien nos hemos esforzado por traducir al español, con la mayor exactitud posible, gran parte del contenido de este sitio web y de los documentos asociados, New American Funding no asume responsabilidad alguna por posibles inexactitudes en la traducción ni por malentendidos derivados de diferencias en el uso del lenguaje o en los dialectos. Para obtener asistencia con la traducción o para solicitar documentos adicionales traducidos al español, por favor contáctenos durante nuestro horario comercial habitual llamando al 877-214-4431.`;

export const ENGLISH_LEGAL_COPY = `New American Funding is pleased to provide Spanish translations of some documents and communications for our Spanish speaking customers. By toggling to Spanish and proceeding past this window, you are indicating your preference to review this webpage and its accompanying documents in Spanish. If you do not wish to proceed in Spanish at this time, please select “Cancel” and you will be returned to the English version of the NAF Hub website.

We have undertaken efforts to translate as many documents as possible, but some documents may remain in English only. The Spanish translations that we have provided are for reference only. The English versions, including the English Uniform Residential Loan Application (URLA), will always be the official legal servicing documents that you will sign and which will be legally binding. If any inconsistencies exist between the Spanish translation and the English URLA, the final, signed English URLA will be considered correct and govern the transaction. Although we have tried to translate much of the content of the website and the associated documents into Spanish accurately, New American Funding is not liable for any inaccuracies in the translation or any misunderstandings because of differences in usage or dialect. To obtain translation assistance or to request additional Spanish translated documents, please contact us during regular business hours at 877-214-4431.`;

// Loan Card default text
export const PROPERTY_PENDING = 'Property Pending';
export const AMOUNT_PENDING = 'Amount Pending';
export const GENERIC_PENDING = 'Pending';